// This file contains the models for different types of grocery documents.
// Each document type has its own structure and properties.

const warehouseItem = {
  id: "",
  name: "",
  location: "",
  notes: "",
};

// The documentGrocery object serves as a base for other document types.
const documentGrocery = {
  id: null,
  notes: null,
  warehouse: null,
  warehouse_id: null,
  document_date: new Date().toISOString().split("T")[0],
  groceries: [],
  number: null,
  number: "",
};

// The writeOffDocumentGrocery object is used for write-off documents.
// It is used when groceries are written off from the warehouse.
const writeOffDocumentGrocery = {
  ...documentGrocery,
  ordered_by: null,
  document_type: "write-off",
};

// The waybillDocumentGrocery object is used for exit documents.
// It is used when groceries are dispatched from the warehouse to another location.
const waybillDocumentGrocery = {
  ...documentGrocery,
  dispatched_by: null,
  received_by: null,
  document_type: "exit",
};

// The orderDocumentGrocery object is used for order documents.
// It is used when groceries are ordered from a supplier.
const orderDocumentGrocery = {
  ...documentGrocery,
  document_type: "order",
  offer_deadline: new Date().toISOString(),
  delivery_deadline: new Date().toISOString(),
};

// The requestOrderDocumentGrocery object is used for request order documents.
// It is used when we want to get a quote from suppliers.
const requestOrderDocumentGrocery = {
  ...documentGrocery,
  document_type: "request",
  offer_deadline: new Date().toISOString(),
  delivery_deadline: new Date().toISOString(),
};

// The storeDocumentGrocery object is used for entry documents.
// It is used when groceries are received into the warehouse.
const storeDocumentGrocery = {
  ...documentGrocery,
  document_type: "entry",
};

// The returnDocumentGrocery object is used for return documents.
// It is used when groceries are returned to the supplier.
const returnDocumentGrocery = {
  ...documentGrocery,
  document_type: "return",
};

const supplier = {
  id: null,
  name: "",
  address: "",
  city: "",
  country: "",
  phone: "",
  email: "",
  jib: "",
  pib: "",
  contact: "",
  note: "",
};

export {
  warehouseItem,
  documentGrocery,
  waybillDocumentGrocery,
  writeOffDocumentGrocery,
  orderDocumentGrocery,
  requestOrderDocumentGrocery,
  storeDocumentGrocery,
  returnDocumentGrocery,
  supplier,
};
